import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { LocalStorage } from '../../library/utilities/localstorage.js';

const RESENT_OTP_DELAY = 60 * 1000

const getTimeLeft = (token) => parseInt((Date.now() - LocalStorage(token).get('lastOtpRequest')) / 1000)

export const OtpResendButton = ({ onClick }) => {
  const { t } = useTranslation()
  const { quotationToken } = useParams()
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(quotationToken))
  const timer = useRef(null)

  useEffect(() => {
    timer.current = setInterval(() => {
      setTimeLeft(getTimeLeft(quotationToken));
    }, 1000);
    return () => {
      clearInterval(timer.current)
    }
  }, [quotationToken])

  if (timeLeft < RESENT_OTP_DELAY / 1000) {
    return (
      <button className='button' disabled>{t('You can resend code after {{delay}} seconds', { delay: (RESENT_OTP_DELAY / 1000 - timeLeft) })}</button>
    )
  }
  return (
    <button className='button' onClick={onClick}>{t('Resend Code')}</button>
  )
}
OtpResendButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default OtpResendButton
